import React, { useCallback, useEffect, useState } from "react";
import { Receipt, WidgetsOutlined, CloudDownload } from "@material-ui/icons";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { formatMoney } from "helpers/Currency";
import MyBadges from "components/MyBadges";
import { useCompany, useUser } from "models";
import FundsRequestService from "services/funds-request";
import { collect } from "helpers/collection";
import { formatDocument } from "helpers/document";
import { formatDateBR } from "helpers/format";
import Unauthorized from "components/Unauthorized";
import { Link } from 'react-router-dom'
import Axios from "axios";
import ExportExcel from "helpers/export/xls";
import { makeid } from "helpers/random";

import "./style.scss";

export default function() {
  const user = useUser();
  const {company} = useCompany();
  const { id: fiscalYear } = {id: 13}
  const tabs = [
    { label: "Disponível para resgate", status: "Liberado"},
    { label: "Aguardando liberação", status: "Pendente"},
    { label: "Aguardando novo pedido", status: "Novo Pedido"},
    { label: "Resgates solicitados", status: [8,9]},
    { label: "Histórico de resgates", status: [9]},
  ]
  // const tabs = [
  //   "Disponível para resgate",
  //   "Aguardando liberação",
  //   "Resgates solicitados",
  //   //"aguardando novo pedido",
  //   "Histórico de resgates",
  // ]
  const [load, setLoad] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(0);
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  
  const [ selected, setSelected ] = useState(tabs[0]);

  const loadMoreCall = useCallback((showLoadMore)=>{
    setLoadMore(true);
    if(company.id && showLoadMore > 0){
      const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ]
      if(selected.label == tabs[0].label || selected.label == tabs[1].label || selected.label == tabs[2].label) {        
        FundsRequestService.getPayments(fiscalYear,company.id,selected.status,showLoadMore).then(({data})=>{
          let {list,total} = data;
          let l = collect(list.map((d)=>{
            try {
              var [y,m] = d.expired_date.split("-");
            } catch (error) {
              var [y,m] = ["-","-"];
            }
            let name = company.company_name;
            if(name.length > 30){
              name = name.substring(0,30)+"...";
            }
            return {
              company:name,
              document:formatDocument(company.document),
              vencimento:formatDateBR(d.expired_date),
              pedido:d.order_billing,
              nf:d.nf,
              valor:selected.label == tabs[0].label?parseFloat(d.real_value):parseFloat(d.value_pending),
              status:selected.label == tabs[0].label?"dpr":"al",
              month:`${y}-${m}`
            }
          })).group('month').map((a,b)=>{
            let [y,m] = b.split("-");
            return {
              range:`${months[parseInt(m)-1]}/${y}`,
              month: b,
              data: a
            }
          }).sortByDesc("month").toArray();
          setData(old=>{
            if(old[old.length-1].month == l[0].month){
              let [f, ...aux] = l;
              old[old.length-1].data = [...old[old.length-1].data, ...f.data]
              return [...old, ...aux]
            }
            return [...old, ...l];
          })
          setLoad(false);
          setShowLoadMore(total > (list.length + showLoadMore*20)?showLoadMore+1:0);
          setLoadMore(false);
        })
      }
    }
  },[company, selected, user])

  useEffect(()=>{
    let token_cancel_request = Axios.CancelToken.source();
    setData([])
    if(company && company.id){
      setLoad(true)
      setShowLoadMore(0);
      const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ]

      if(selected.label === tabs[0].label || selected.label === tabs[1].label){
        FundsRequestService.getPayments(token_cancel_request.token,fiscalYear,company.id,selected.status).then(({data})=>{
          let {list,total} = data;
          let l = collect(list.map((d)=>{
            try {
              var [y,m] = d.expired_date.split("-");
            } catch (error) {
              var [y,m] = ["-","-"];
            }
            let name = company.company_name;
            if(name.length > 30){
              name = name.substring(0,30)+"...";
            }
            return {
              company:name,
              document:formatDocument(company.document),
              filial: d.filial,
              filial_document: formatDocument(d.filial_document),
              vencimento:formatDateBR(d.expired_date),
              pedido:d.order_billing,
              nf:d.nf,
              valor:selected.label == tabs[0].label?parseFloat(d.real_value):parseFloat(d.value_pending),
              status:selected.label == tabs[0].label?"dpr":"al",
              month:`${y}-${m}`,
              fund_status: d.fund_status,
              payment_status: d.payment_status,
              order_status: d.order_status
            }
          })).group('month').map((a,b)=>{
            let [y,m] = b.split("-");
            return {
              range:`${months[parseInt(m)-1]}/${y}`,
              month: b,
              data: a
            }
          }).sortByDesc("month").toArray();
          setData(l)
          setLoad(false);
          setShowLoadMore(total > list.length?1:0);
        })
      } else if(selected.label === tabs[3].label || selected.label === tabs[4].label){
        FundsRequestService.getRescues(token_cancel_request.token,fiscalYear,company.id,selected.status).then(({data})=>{
          let {list,total} = data;
          let l = collect(list.map((d)=>{
            let [y,m] = d.created_at?d.created_at.split(" ")[0].split("T")[0].split("-"):[0,0];
            let name = company.company_name;
            if(name.length > 30){
              name = name.substring(0,30)+"...";
            }
            return {
              type:d.type_id===2?"Resgate":"Encontro de contas",
              description:d.title,
              valor:d.value,
              payment_date:d.pay_date?formatDateBR(d.pay_date):"-",
              status:d.action_status_id===9?"r":"pp",
              month:`${y}-${m}`
            }
          })).group('month').map((a,b)=>{
            let [y,m] = b.split("-");
            return {
              range:(y==='0')?"---":`${months[parseInt(m)-1]}/${y}`,
              month: b,
              data: a
            }
          }).sortByDesc("month").toArray();
          setData(l)
          setLoad(false);
          setShowLoadMore(total > list.length?1:0);
        })
      }

    } else {
      setError(true)
    }

    return ()=>{
      if(token_cancel_request)
      token_cancel_request.cancel('Não é mais de meu interesse enviar esta requisição.');
    }
  },[company, selected, user]);

  const export_excel = useCallback(async(target)=>{
    // console.log(target)
    target.disabled = true;
    let percent = 0;
    target.setAttribute("data-percent", percent+"%")
    const months = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro'
    ];
    async function getData(selected){
      let token_cancel_request = Axios.CancelToken.source();
      if(selected.label === tabs[0].label || selected.label === tabs[1].label){
        let {data} = await FundsRequestService.getPayments(token_cancel_request.token,fiscalYear,company.id,selected.status);//.then(({data})=>{
        let {list} = data;
        var l = collect(list.map((d)=>{
          try {
            var [y,m] = d.expired_date.split("-");
          } catch (error) {
            var [y,m] = ["-","-"];
          }
          let name = company.company_name;
          if(name.length > 30){
            name = name.substring(0,30)+"...";
          }
          return {
            company:name,
            document:formatDocument(company.document),
            vencimento:formatDateBR(d.expired_date),
            pedido:d.order_billing,
            nf:d.nf,
            valor:selected.label == tabs[0].label?parseFloat(d.real_value):parseFloat(d.value_pending),
            status:selected.label == tabs[0].label?"dpr":"al",
            month:`${y}-${m}`
          }
        })).group('month').map((a,b)=>{
          let [y,m] = b.split("-");
          return {
            range:`${months[parseInt(m)-1]}/${y}`,
            month: b,
            data: a
          }
        }).sortBy("month").toArray();
      } else if(selected === tabs[3] || selected === tabs[4]){
        let {data} = await FundsRequestService.getRescues(token_cancel_request.token,fiscalYear,company.id,selected.status)
        let {list} = data;
        var l = collect(list.map((d)=>{
          let [y,m] = d.created_at?d.created_at.split(" ")[0].split("T")[0].split("-"):[0,0];
          let name = company.company_name;
          if(name.length > 30){
            name = name.substring(0,30)+"...";
          }
          return {
            type:d.type_id===2?"Resgate":"Encontro de contas",
            description:d.title,
            valor:d.value,
            payment_date:d.pay_date?formatDateBR(d.pay_date):"-",
            status:d.action_status_id===9?"r":"pp",
            month:`${y}-${m}`
          }
        })).group('month').map((a,b)=>{
          let [y,m] = b.split("-");
          return {
            range:(y==='0')?"---":`${months[parseInt(m)-1]}/${y}`,
            month: b,
            data: a
          }
        }).sortBy("month").toArray();
      } else {
        var l = [];
      }
      target.setAttribute("data-percent", (percent+=(100/tabs.length))+"%")
      return l;

    }
    async function getTable1(){
      let l1 = await getData(tabs[0]);
      let idTable = makeid(6);
      return (
        <table>
          <tr>
            <th colSpan="5" style={{textAlign: "center"}}>Disponível para resgate</th>
            <th style={{textAlign: "right"}}>Total</th>
            <th data-style="currency:BRL" data-formula={`%f u [+...] ${idTable}`}></th>
          </tr>
          {l1.map((item)=>{
            let id = makeid(5);
            return (<React.Fragment key={item.range}>
              <tr style={{backgroundColor:"#b4c5e7"}}><th colSpan="7">{item.range}</th></tr>
              <tr>
                <th>Revenda</th>
                <th>CNPJ</th>
                <th>Vencimento</th>
                <th>Pedido</th>
                <th>Nota Fiscal</th>
                <th>Valor</th>
                <th>Status</th>
              </tr>
              {(()=>{
                let r = (
                  <>
                    {item.data.map((fund,key)=>{
                      return (
                        <tr key={key}>
                          <td><b>{fund.company}</b></td>
                          <td>{fund.document}</td>
                          <td>{fund.vencimento}</td>
                          <td><b>{fund.pedido}</b></td>
                          <td><b>{fund.nf}</b></td>
                          <td data-style="currency:BRL" id-to-form={id}>{fund.valor}</td>
                          <td>Disponível para resgate</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={5} style={{textAlign:"right"}}><b>Total</b></td>
                      <td data-style="currency:BRL" id-to-form={idTable} data-formula={`%f r r+ ${id}`}><b></b></td>
                      <td></td>
                    </tr>
                  </>
                );
                return r;
              })()}
            </React.Fragment>);
          })}
        </table>
      );
    }
    async function getTable2(){
      let l1 = await getData(tabs[1]);
      let idTable = makeid(6);
      return (
        <table>
          <tr>
            <th colSpan="5" style={{textAlign: "center"}}>Aguardando liberação</th>
            <th style={{textAlign: "right"}}>Total</th>
            <th data-style="currency:BRL" data-formula={`%f u [+...] ${idTable}`}></th>
          </tr>
          {l1.map((item)=>{
            let id = makeid(5);
            return (<React.Fragment key={item.range}>
              <tr style={{backgroundColor:"#b4c5e7"}}><th colSpan="7">{item.range}</th></tr>
              <tr>
                <th>Revenda</th>
                <th>CNPJ</th>
                <th>Vencimento</th>
                <th>Pedido</th>
                <th>Nota Fiscal</th>
                <th>Valor</th>
                <th>Status</th>
              </tr>
              {(()=>{
                let r = (
                  <>
                    {item.data.map((fund,key)=>{
                      return (
                        <tr key={key}>
                          <td><b>{fund.company}</b></td>
                          <td>{fund.document}</td>
                          <td>{fund.vencimento}</td>
                          <td><b>{fund.pedido}</b></td>
                          <td><b>{fund.nf}</b></td>
                          <td data-style="currency:BRL" id-to-form={id}>{fund.valor}</td>
                          <td>{fund.status==="ri"?"Resgate invalidado":"Aguardando liberação"}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={5} style={{textAlign:"right"}}><b>Total</b></td>
                      <td data-style="currency:BRL" id-to-form={idTable} data-formula={`%f r r+ ${id}`}><b></b></td>
                      <td></td>
                    </tr>
                  </>
                );
                return r;
              })()}
            </React.Fragment>);
          })}
        </table>
      );
    }    
    async function getTable3(){
      let l1 = await getData(tabs[2]);
      let idTable = makeid(6);
      return (
        <table>
          <tr>
            <th colSpan="5" style={{textAlign: "center"}}>Aguardando novo pedido</th>
            <th style={{textAlign: "right"}}>Total</th>
            <th data-style="currency:BRL" data-formula={`%f u [+...] ${idTable}`}></th>
          </tr>
          {l1.map((item)=>{
            let id = makeid(5);
            return (<React.Fragment key={item.range}>
              <tr style={{backgroundColor:"#b4c5e7"}}><th colSpan="7">{item.range}</th></tr>
              <tr>
                <th>Revenda</th>
                <th>CNPJ</th>
                <th>Vencimento</th>
                <th>Pedido</th>
                <th>Nota Fiscal</th>
                <th>Valor</th>
                <th>Status</th>
              </tr>
              {(()=>{
                let r = (
                  <>
                    {item.data.map((fund,key)=>{
                      return (
                        <tr key={key}>
                          <td><b>{fund.company}</b></td>
                          <td>{fund.document}</td>
                          <td>{fund.vencimento}</td>
                          <td><b>{fund.pedido}</b></td>
                          <td><b>{fund.nf}</b></td>
                          <td data-style="currency:BRL" id-to-form={id}>{fund.valor}</td>
                          <td>Disponível para resgate</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={5} style={{textAlign:"right"}}><b>Total</b></td>
                      <td data-style="currency:BRL" id-to-form={idTable} data-formula={`%f r r+ ${id}`}><b></b></td>
                      <td></td>
                    </tr>
                  </>
                );
                return r;
              })()}
            </React.Fragment>);
          })}
        </table>
      );
    }
    async function getTable4(){
      let l1 = await getData(tabs[3]);
      let idTable = makeid(6);
      return (
        <table>
          <tr>
            <th colSpan="3" style={{textAlign: "center"}}>Aguardando liberação</th>
            <th style={{textAlign: "right"}}>Total</th>
            <th data-style="currency:BRL" data-formula={`%f u [+...] ${idTable}`}></th>
          </tr>
          {l1.map((item)=>{
            let id = makeid(5);
            return (<React.Fragment key={item.range}>
              <tr style={{backgroundColor:"#b4c5e7"}}><th colSpan="5">{item.range}</th></tr>
              <tr>
                <th>Tipo</th>
                <th>Descrição</th>
                <th>Valor</th>
                <th>Data pagamento</th>
                <th style={{width:"1px"}}>Status</th>
              </tr>
              {(()=>{
                let r = (
                  <>
                    {item.data.map((action,key)=>{
                      return (
                        <tr key={key}>
                          <td><b>{action.type}</b></td>
                          <td>{action.description}</td>
                          <td data-style="currency:BRL" id-to-form={id}>{action.valor}</td>
                          <td>{action.payment_date}</td>
                          <td>{action.status==="r"?"Resgatado":"Processando pagamento"}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={2} style={{textAlign:"right"}}><b>Total</b></td>
                      <td data-style="currency:BRL" id-to-form={idTable} data-formula={`%f r r+ ${id}`}><b></b></td>
                      <td></td>
                    </tr>
                  </>
                );
                return r;
              })()}
            </React.Fragment>);
          })}
        </table>
      );
    }
    async function getTable5(){
      let l1 = await getData(tabs[4]);
      let idTable = makeid(6);
      return (
        <table>
          <tr>
            <th colSpan="3" style={{textAlign: "center"}}>Histórico de resgates</th>
            <th style={{textAlign: "right"}}>Total</th>
            <th data-style="currency:BRL" data-formula={`%f u [+...] ${idTable}`}></th>
          </tr>
          {l1.map((item)=>{
            let id = makeid(5);
            return (<React.Fragment key={item.range}>
              <tr style={{backgroundColor:"#b4c5e7"}}><th colSpan="5">{item.range}</th></tr>
              <tr>
                <th>Tipo</th>
                <th>Descrição</th>
                <th>Valor</th>
                <th>Data pagamento</th>
                <th style={{width:"1px"}}>Status</th>
              </tr>
              {(()=>{
                let r = (
                  <>
                    {item.data.map((action,key)=>{
                      return (
                        <tr key={key}>
                          <td><b>{action.type}</b></td>
                          <td>{action.description}</td>
                          <td data-style="currency:BRL" id-to-form={id}>{action.valor}</td>
                          <td>{action.payment_date}</td>
                          <td>{action.status==="r"?"Resgatado":"Processando pagamento"}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={2} style={{textAlign:"right"}}><b>Total</b></td>
                      <td data-style="currency:BRL" id-to-form={idTable} data-formula={`%f r r+ ${id}`}><b></b></td>
                      <td></td>
                    </tr>
                  </>
                );
                return r;
              })()}
            </React.Fragment>);
          })}
        </table>
      );
    }
    try {
      if(company && company.id){
        let export_obj = ExportExcel([
          await getTable1(),
          await getTable2(),
          //await getTable3(),
          await getTable4(),
          await getTable5()
        ],
        tabs.filter(tab => tab.status != "Novo Pedido").map(tab => tab.label),
        `Fundos Elite Pass ${company.company_name} %date`)
        // target.setAttribute("data-percent", (percent+=20)+"%")
        setTimeout(()=>{
          export_obj.download();
          target.disabled = false;
        },400);
      }
    } catch (error) {target.disabled = false;}
  },[company, user]);

  if(error){
    return <Unauthorized/>;
  }

  return (
    <Container className="page-fund-scancash">
      {/* <Row className="mt-4">
        <Button variant="link" className="link-back" onClick={() => history.goBack()}>
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Button>
      </Row> */}
      <Row className="mt-3 align-items-end justify-content-between">
        <Col xs="auto" className="d-flex">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Fundos Elite Pass</h5>
        </Col>
        <Col xs="auto">
          <Row>
            <Col xs="auto" className='align-self-end'>
              <Link to="/elite/elite-pass">
                <Button><Receipt/> Fluxo de Elite Pass</Button>
              </Link>
            </Col>
            <Col xs="auto" className='align-self-end'>
              <Button className="btn-load" data-percent="0%" onClick={(e)=>export_excel(e.target)}><CloudDownload/> Exportar</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Card.Body className="card-dashboard shadow bg-white rounded w-100 mt-2 p-0">
        <Row className="justify-content-center page-tabs">
          {tabs.filter(tab => tab.status != "Novo Pedido").map((item) => {
            return (
              <Col key={item.label} className="text-center page-tabs-item" xs="auto">
                <div className={item.label===selected.label?"selected":""} onClick={()=>{setSelected(item)}}>{item.label}</div>
              </Col>
            );
          })}
        </Row>
      </Card.Body>
      <Card.Body className="card-dashboard shadow bg-white rounded w-100 mt-3 list-data">
        {load?(
          <div style={{textAlign:"center"}}>
            <Spinner animation="border"/>
          </div>
        ):(<>
          {selected.label === tabs[0].label?(
            <div>
              {(()=>{
                let total_data = 0;
                return <>
                  {data.map((item)=>{
                    return (
                      <div key={item.range}>
                        <label>{item.range}</label>
                        <table className="table2">
                          <thead>
                            <tr>
                              <th>Revenda</th>
                              <th>CNPJ</th>
                              <th>Vencimento</th>
                              <th>Pedido</th>
                              <th>Nota Fiscal</th>
                              <th>Valor</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          {(()=>{
                            let total = 0;
                            let r = (
                              <>
                                <tbody>
                                  {item.data.map((fund,key)=>{
                                    total+=fund.valor;
                                    return (
                                      <tr key={key}>
                                        <td><b>{fund.company}</b></td>
                                        <td>{fund.document}</td>
                                        <td>{fund.vencimento}</td>
                                        <td><b>{fund.pedido}</b></td>
                                        <td><b>{fund.nf}</b></td>
                                        <td>{formatMoney(fund.valor)}</td>
                                        <td><MyBadges variant="success">Disponível para resgate</MyBadges></td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>{formatMoney(total)}</b></td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </>
                            );
                            total_data += total;
                            return r;
                          })()}
                        </table>
                      </div>
                    );
                  })}
                  <div className="list-data-total-data">
                    <span><b>Total disponibilizado até agora: </b>{formatMoney(total_data)}</span>
                  </div>
                </>
              })()}
            </div>
          ):<></>}
          {selected.label === tabs[1].label?(
            <div>
              {(()=>{
                let total_data = 0;
                return <>
                  {data.map((item)=>{
                    return (
                      <div key={item.range}>
                        <label>{item.range}</label>
                        <table className="table2">
                          <thead>
                            <tr>
                              <th>Revenda</th>
                              <th>CNPJ</th>
                              <th>Vencimento</th>
                              <th>Pedido</th>
                              <th>Nota Fiscal</th>
                              <th>Valor</th>
                              <th>Status Verba</th>
                              <th>Status Pagamento</th>
                              <th>Status Novo Pedido</th>
                            </tr>
                          </thead>
                          {(()=>{
                            let total = 0;
                            let r = (
                              <>
                                <tbody>
                                  {item.data.map((fund,key)=>{
                                    total+=fund.valor;
                                    return (
                                      <tr key={key}>
                                        <td><b>{fund.filial}</b></td>
                                        <td>{fund.filial_document}</td>
                                        <td>{fund.vencimento}</td>
                                        <td><b>{fund.pedido}</b></td>
                                        <td><b>{fund.nf}</b></td>
                                        <td>{formatMoney(fund.valor)}</td>
                                        {/* <td>{fund.status==="ri"?<MyBadges variant="danger">Resgate invalidado</MyBadges>:<MyBadges variant="warning">Aguardando liberação</MyBadges>}</td> */}
                                        <td style={{color: "#dba97d"}}>{fund.fund_status}</td>
                                        <td style={{color: "#dba97d"}}>{fund.payment_status}</td>
                                        <td style={{color: "#dba97d"}}>{fund.order_status}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>{formatMoney(total)}</b></td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </>
                            );
                            total_data += total;
                            return r;
                          })()}
                        </table>
                      </div>
                    );
                  })}
                  <div className="list-data-total-data">
                    <span><b>Total: </b>{formatMoney(total_data)}</span>
                  </div>
                </>
              })()}
            </div>
          ):<></>}          
          {/* {selected.label === tabs[2].label?(
            <div>
              {(()=>{
                let total_data = 0;
                return <>
                  {data.map((item)=>{
                    return (
                      <div key={item.range}>
                        <label>{item.range}</label>
                        <table className="table2">
                          <thead>
                            <tr>
                              <th>Revenda</th>
                              <th>CNPJ</th>
                              <th>Vencimento</th>
                              <th>Pedido</th>
                              <th>Nota Fiscal</th>
                              <th>Valor</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          {(()=>{
                            let total = 0;
                            let r = (
                              <>
                                <tbody>
                                  {item.data.map((fund,key)=>{
                                    total+=fund.valor;
                                    return (
                                      <tr key={key}>
                                        <td><b>{fund.company}</b></td>
                                        <td>{fund.document}</td>
                                        <td>{fund.vencimento}</td>
                                        <td><b>{fund.pedido}</b></td>
                                        <td><b>{fund.nf}</b></td>
                                        <td>{formatMoney(fund.valor)}</td>
                                        <td><MyBadges variant="success">Disponível para resgate</MyBadges></td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>{formatMoney(total)}</b></td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </>
                            );
                            total_data += total;
                            return r;
                          })()}
                        </table>
                      </div>
                    );
                  })}
                  <div className="list-data-total-data">
                    <span><b>Total disponibilizado até agora: </b>{formatMoney(total_data)}</span>
                  </div>
                </>
              })()}
            </div>
          ):<></>} */}
          {selected.label === tabs[3].label?(
            <div>
              {(()=>{
                let total_data = 0;
                return <>
                  {data.map((item)=>{
                    return (
                      <div key={item.range}>
                        <label>{item.range}</label>
                        <table className="table2">
                          <thead>
                            <tr>
                              <th>Tipo</th>
                              <th>Descrição</th>
                              <th>Valor</th>
                              <th>Data pagamento</th>
                              <th style={{width:"1px"}}>Status</th>
                            </tr>
                          </thead>
                          {(()=>{
                            let total = 0;
                            let r = (
                              <>
                                <tbody>
                                  {item.data.map((action,key)=>{
                                    total+=action.valor;
                                    return (
                                      <tr key={key}>
                                        <td><b>{action.type}</b></td>
                                        <td>{action.description}</td>
                                        <td>{formatMoney(action.valor)}</td>
                                        <td>{action.payment_date}</td>
                                        <td><MyBadges variant="success" nowrap>{action.status==="r"?"Resgatado":"Processando pagamento"}</MyBadges></td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>{formatMoney(total)}</b></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </>
                            );
                            total_data += total;
                            return r;
                          })()}
                        </table>
                      </div>
                    );
                  })}
                  <div className="list-data-total-data">
                    <span><b>Total: </b>{formatMoney(total_data)}</span>
                  </div>
                </>
              })()}
            </div>
          ):<></>}
          {selected.label === tabs[4].label?(
            <div>
              {(()=>{
                let total_data = 0;
                return <>
                  {data.map((item)=>{
                    return (
                      <div key={item.range}>
                        <label>{item.range}</label>
                        <table className="table2">
                          <thead>
                            <tr>
                              <th>Tipo</th>
                              <th>Descrição</th>
                              <th>Valor</th>
                              <th>Data pagamento</th>
                              <th style={{width:"1px"}}>Status</th>
                            </tr>
                          </thead>
                          {(()=>{
                            let total = 0;
                            let r = (
                              <>
                                <tbody>
                                  {item.data.map((action,key)=>{
                                    total+=action.valor;
                                    return (
                                      <tr key={key}>
                                        <td><b>{action.type}</b></td>
                                        <td>{action.description}</td>
                                        <td>{formatMoney(action.valor)}</td>
                                        <td>{action.payment_date}</td>
                                        <td><MyBadges variant="success" nowrap>{action.status==="r"?"Resgatado":"Processando pagamento"}</MyBadges></td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>{formatMoney(total)}</b></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </>
                            );
                            total_data += total;
                            return r;
                          })()}
                        </table>
                      </div>
                    );
                  })}
                  <div className="list-data-total-data">
                    <span><b>Total: </b>{formatMoney(total_data)}</span>
                  </div>
                </>
              })()}
            </div>
          ):<></>}
          {showLoadMore?(
            <div>
              <Button onClick={()=>loadMoreCall(showLoadMore)} disabled={loadMore}>{loadMore?<Spinner animation="border"/>:"Carregar Mais"}</Button>
            </div>
          ):<></>}
        </>)}
      </Card.Body>
    </Container>
  );
}